import { DEFAULT_VALUE } from '@constants/common';

import { DateRange } from '@containers/insights/type';
import { IUser } from '../types/common';
import { getFormattedDate, getFullMonthAndYear } from './date';

export const nameFormatter = (user: IUser) => {
  const firstName = user?.firstName?.trim();
  const lastName = user?.lastName?.trim();
  if (firstName || lastName) return `${firstName} ${lastName}`;
  return DEFAULT_VALUE;
};

export const getUniqueList = (currentList = [], newList = []) => {
  // The getDeviceUsers query fetched for all users [owner + member], hence multiple devices with same device id & device name is present in the list. Here showing only the ones having unique device-id - device-name combo
  let combinedList = [...currentList, ...newList];
  if (newList.length) {
    combinedList = [
      ...new Map(
        combinedList.map((obj) => [JSON.stringify(obj), obj])
      ).values(),
    ];
  }
  return combinedList;
};

export const formatWithUnit = (value, unit = '', acceptZero = true) => {
  if (value) return `${value} ${unit}`;
  if (value === 0) return acceptZero ? `${value} ${unit}` : value;
  return DEFAULT_VALUE;
};

export const dateRangeDisplayFormat = (
  activeTabLabel: number,
  dateRange: DateRange
): string => {
  switch (activeTabLabel) {
    case 0:
      return `${getFormattedDate(dateRange.startDate, 'DD-MM-YYYY')} `;
    case 1:
      return `${getFormattedDate(
        dateRange.startDate,
        'DD-MM-YYYY'
      )} - ${getFormattedDate(dateRange.endDate, 'DD-MM-YYYY')}`;
    default:
      return getFullMonthAndYear(dateRange.startDate);
  }
};

export const replaceUnderscore = (toReplaceString: string): string => {
  const result = toReplaceString?.replaceAll('_', ' ');
  return result;
};
export const replaceWithName = (toReplaceString: string): string => {
  const modelName = {
    SENTRY: '2024 Sentry (Gate Lock)',
    SENTRY_PRO: '2024 Sentry Pro (Gate Lock)',
    SENTINEL: '2024 Sentinel (Door Lock)',
    SENTINEL_PRO: '2024 Sentinel Pro (Door Lock)',
    SENTINEL_V2: 'Sentinel (Door Lock)',
    SENTINEL_PRO_V2: 'Sentinel Ultra (Door Lock)',
    SLIM_MORTISE: 'Spectre (Door Lock)',
    SLIM_MORTISE_PRO: 'Spectre Ultra (Door Lock)',
    SENTRY_V2: 'Sentry (Gate Lock)',
    SENTRY_PRO_V2: 'Sentry Ultra (Gate Lock)',
    SENTRY_GATE: 'Sentry (Privacy)/Sentra (Gate Lock)',
    SENTRY_GATE_PRO: 'Sentry (Privacy)/Sentra Ultra (Gate Lock)',
  };
  const result =
    modelName[toReplaceString]?.toUpperCase() ||
    toReplaceString?.replaceAll('_', ' ');
  return result;
};
